import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  AccountApplicants = 'AccountApplicants',
}

export const queryKeys = {
  accountApplicants: (clientId: string, managedAccountId: string) => [
    QueryFeature.MyAccount,
    QueryKey.AccountApplicants,
    clientId,
    managedAccountId,
  ],
};
